import { css } from '@emotion/core';
import { useIntl } from 'gatsby-plugin-intl';
import React from 'react';
import { Desktop, Tablet } from '../../constants/responsive';

const Card = ({ name }) => {
  const intl = useIntl();
  return (
    <div
      css={css`
        width: 324px;
        text-align: left;
        margin-bottom: 20px;
        :last-child {
          margin-bottom: 0px;
        }
        ${Tablet} {
          width: 220px;
          margin-bottom: 0px;
          :last-child {
            margin-bottom: 0px;
          }
        }
        ${Desktop} {
          width: 357px;
        }
      `}
    >
      <i
        css={css`
            width: 60px;
            height: 60px;
            display: inline-block;
            background: url(/product/${name}.png) center no-repeat;
            background-size: contain;
            // ${Desktop} {
            //   margin-right: 28px;
            //   margin-left: 0px;
            // }
          `}
      />
      <div
        css={css`
          color: #161616;
          font-size: 18px;
          font-weight: 500;
          line-height: 1.22;
          ${Tablet} {
            font-size: 18px;
            font-weight: 500;
            line-height: 1.11;
          }
          ${Desktop} {
            font-size: 20px;
            font-weight: bold;
            line-height: 1.75;
          }
        `}
      >
        {intl.formatMessage({
          id: `individuals.what-you-get.${name}.title`,
        })}
      </div>
      <div
        css={css`
          color: #161616;
          font-weight: normal;
          font-size: 14px;
          // line-height: 1.71;
          margin-top: 10px;
          ${Tablet} {
            font-size: 14px;
            // line-height: 1.71;
            margin-top: 9px;
          }
          ${Desktop} {
            font-size: 20px;
            // line-height: 1.75;
            margin-top: 6px;
          }
        `}
      >
        {intl.formatMessage({
          id: `individuals.what-you-get.${name}.description`,
        })}
      </div>
    </div>
  );
};

const WhatYouGet = ({ advantages = [] }) => {
  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        ${Tablet} {
          display: flex;
          justify-content: space-between;
          flex-direction: row;
        }
        ${Desktop} {
          display: flex;
          justify-content: space-between;
        }
      `}
    >
      <Card name={advantages[0]}></Card>
      <Card name={advantages[1]}></Card>
      <Card name={advantages[2]}></Card>
    </div>
  );
};

export default WhatYouGet;
